export default "__VITE_ASSET__D1$7Fr_b__"